import { useEffect, useState } from 'react'
import { useDidMountEffect } from './shared_functions'
import Notification from './notification'

const GroupNotificationPopup = ({ id, hideGroupNotification, notificationsPath, updateParentNotification }) => {
  const popupId = `group_notification_${id}`
  const [page, setPage] = useState(1)
  const [notifications, setNotifications] = useState([])
  const [visibleNextPageLink, setVisibleNextPageLink] = useState(false)

  useEffect(() => {
    fetchNotifications()
  }, [])

  useDidMountEffect(() => {
    window.magnify()
  }, [notifications])

  useDidMountEffect(() => {
    fetchNotifications(page != 1)
  }, [page])

  const nextPage = (e) => {
    e.preventDefault()
    setPage(page + 1)
  }

  const fetchNotifications = (append = false) => {
    jQuery.ajax({
      method: 'GET',
      url: `${notificationsPath}/${id}/children`,
      data: {
        per: 25,
        page: page
      },
      success: (data) => {
        if (append) {
          let arr = notifications.concat(data.results)

          arr = _.uniqWith(arr, (arrVal, othVal) => {
            return arrVal.id == othVal.id
          })

          setNotifications(arr)
        } else {
          setNotifications(data.results)
        }

        setVisibleNextPageLink(data.next_page != null)
      }
    })
  }

  const updateNotification = (notification_id, data) => {
    let notification = _.find(notifications, { id: notification_id })

    if (notification) {
      let newNotifications = notifications.map((i) => {
        if (i.id == notification.id) {
          return Object.assign(i, data)
        } else {
          return i
        }
      })
      setNotifications(newNotifications)

      jQuery.ajax({
        method: 'PATCH',
        url: notificationsPath + '/' + notification_id,
        data: {
          notification: data
        },
        success: () => {
          window.app.fetchData(true)
        }
      })
    }
  }

  const readAll = (e) => {
    e.preventDefault()
    updateAll({ status: 'read' })
  }

  const unreadAll = (e) => {
    e.preventDefault()
    updateAll({ status: 'unread' })
  }

  const updateAll = (updateData) => {
    jQuery.ajax({
      method: 'PATCH',
      url: `${notificationsPath}/${id}`,
      data: {
        notification: updateData
      },
      success: () => {
        let newNotifications = notifications.map((n) => {
          return Object.assign(n, updateData)
        })
        setNotifications(newNotifications)
        updateParentNotification(updateData)

        window.app.fetchData(true)
      }
    })
  }

  return (
    <div className="group-notification-popup">
      <h1>{I18n.t('activerecord.models.notification', { count: 2 })}</h1>

      {notifications.length ? (
        <>
          <div className="actions">
            <a href="#" onClick={readAll} className="btn btn-sm btn-thin mr-8">
              <i className="cico fa-light fa-check"></i>
              {I18n.t('notification-read-all')}
            </a>
            <a href="#" onClick={unreadAll} className="btn btn-sm btn-thin">
              <i className="cico fa-light fa-minus"></i>
              {I18n.t('notification-unread-all')}
            </a>
          </div>

          <div className="notifications-container">
            {notifications.map((notification) => (
              <Notification
                key={notification.id}
                notification={notification}
                updateNotification={updateNotification}
                notificationsPath={notificationsPath}
              />
            ))}
          </div>

          {visibleNextPageLink ? (
            <div className="text-center">
              <a href="#" className="btn btn-default" onClick={nextPage}>
                {I18n.t('load-more')}
              </a>
            </div>
          ) : null}
        </>
      ) : (
        <div>{I18n.t('you-have-no-notification')}</div>
      )}
    </div>
  )
}

export default GroupNotificationPopup
